"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _lodash = require("lodash");

var _calicoUiUtilities = require("@calico/calico-ui-utilities");

var _Author = _interopRequireDefault(require("./Author"));

var _Mailto = _interopRequireDefault(require("./Mailto"));

var _ref = _react.default.createElement("span", null, "Email corresponding authors");

var _ref2 = _react.default.createElement("span", null, " ");

var AuthorList =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AuthorList, _React$Component);

  function AuthorList() {
    (0, _classCallCheck2.default)(this, AuthorList);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AuthorList).apply(this, arguments));
  }

  (0, _createClass2.default)(AuthorList, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style;
      var _this$props2 = this.props,
          authorClassName = _this$props2.authorClassName,
          authorStyle = _this$props2.authorStyle;
      var _this$props3 = this.props,
          authors = _this$props3.authors,
          contactSubject = _this$props3.contactSubject,
          showContact = _this$props3.showContact;
      var correspondingAuthors = (0, _lodash.filter)(authors, {
        corresponding: true
      });
      var correspondingEmails = (0, _lodash.filter)((0, _lodash.map)(correspondingAuthors, function (author) {
        return author.email;
      }), function (email) {
        return !(0, _lodash.isEmpty)(email);
      });
      return _react.default.createElement("div", {
        className: (0, _classnames.default)('author-list', className),
        style: style
      }, authors.map(function (author, a) {
        return _react.default.createElement(_Author.default, {
          affiliations: author.affiliations,
          className: authorClassName,
          credentials: author.credentials,
          email: author.email,
          key: a,
          nameFirst: author.nameFirst,
          nameLast: author.nameLast,
          researchGate: author.researchGate,
          style: authorStyle,
          title: author.title
        });
      }), showContact && (0, _lodash.size)(correspondingEmails) > 0 && _react.default.createElement("div", null, _react.default.createElement(_Mailto.default, {
        email: correspondingEmails.join(','),
        subject: contactSubject || 'Contact regarding research'
      }, _ref, _ref2), _react.default.createElement("span", {
        style: {
          opacity: 0.7
        }
      }, (0, _calicoUiUtilities.oxfordJoin)((0, _lodash.map)(correspondingAuthors, function (author) {
        return "".concat(author.nameFirst, " ").concat(author.nameLast);
      })))));
    }
  }]);
  return AuthorList;
}(_react.default.Component);

AuthorList.defaultProps = {
  authors: [],
  contactSubject: null,
  showContact: true
};
var _default = AuthorList;
exports.default = _default;